import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class ModuleBlockSlider {

  constructor(){
    this.slider = jQuery(`[data-trigger='module-block-slider']`);
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        this.slider.owlCarousel({
          autoplay:        true,
          autoplayTimeout: 5000,
          dots:            false,
          items:           1,
          loop:            true,
          nav:             true,
          navText:         ['<','>'],
        });

      }  

    });
  }

}

export const moduleBlockSlider = new ModuleBlockSlider();